import ArtistsIcon from "mdi-react/AccountSupervisorOutlineIcon";
import AwardsIcon from "mdi-react/AwardIcon";
import Partnersicon from "mdi-react/DomainIcon";
import FaqsIcon from "mdi-react/FrequentlyAskedQuestionsIcon";
import MediaIcon from "mdi-react/MediaNetworkIcon";
import NewsIcon from "mdi-react/NewspaperIcon";
import ProjectsIcon from "mdi-react/NotebookIcon";
import WebinarsIcon from "mdi-react/VideoIcon";
import PropTypes from "prop-types";
import { MouseEventHandler, ReactElement } from "react";
import { NavLink } from "react-router-dom";
import { Badge } from "reactstrap";
import styles from "./SideBarLink.module.scss";

interface ISidebarLink {
  title?: string;
  icon?: string;
  newLink?: boolean;
  route: string | null;
  onClick: MouseEventHandler<HTMLAnchorElement>;
  dataTestId?: string;
}

const iconMap = {
  Partners: <Partnersicon />,
  FAQs: <FaqsIcon />,
  News: <NewsIcon />,
  Webinars: <WebinarsIcon />,
  Artists: <ArtistsIcon />,
  Awards: <AwardsIcon />,
  Projects: <ProjectsIcon />,
  Media: <MediaIcon />,
};

const SidebarLink = ({
  title,
  icon = "",
  newLink = false,
  route = "/",
  onClick = () => {},
  dataTestId,
}: ISidebarLink): ReactElement => {
  if (route) {
    return (
      <NavLink
        to={route}
        onClick={onClick}
        activeClassName="sidebar__link-active"
        data-testid={dataTestId}
        className={styles.sidebarLink}
      >
        <li className={"sidebar__link"}>
          {icon ? (
            <span className={`sidebar__link-icon lnr lnr-${icon}`} />
          ) : (
            <span className={styles.icon}>
              {iconMap[`${title as keyof typeof iconMap}`]}
            </span>
          )}
          <p className="sidebar__link-title">
            {title}
            {newLink ? (
              <Badge className="sidebar__link-badge">
                <span>New</span>
              </Badge>
            ) : (
              ""
            )}
          </p>
        </li>
      </NavLink>
    );
  }

  return <></>;
};

SidebarLink.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  newLink: PropTypes.bool,
  route: PropTypes.string,
  onClick: PropTypes.func,
};

export default SidebarLink;
